'use client'

import { SummaryPanel } from '../components/summary-panel/SummaryPanel'
import { WeeklyTable } from '../components/weekly-table/WeeklyTable'
import { useAccount } from '@/domain/hooks/useAccount'
import { PointsSkeleton } from '../components/skeleton/PointsSkeleton'
import { useChainId } from 'wagmi'
import { Panel } from '@/ui/atoms/panel/Panel'
import { useUserPoints } from '@/domain/merkl/user-points/useUserPoints'
import { Typography } from '@/ui/atoms/typography/Typography'
import { useUserRank } from '@/domain/merkl/points-leaderboard/useUserRank'
import { LeaderboardContainer } from '../LeaderboardContainer'

export const HIDE_POINTS_SECTION = true

export function PointsView() {
  const account = useAccount()
  const chainId = useChainId()

  const { data: userPoints, isLoading: isUserPointsLoading } = useUserPoints({ account, chainId })
  const { userRank } = useUserRank()

  const isAllLoading = isUserPointsLoading

  return (
    <div className="flex flex-col gap-4">
      {isAllLoading ? (
        <PointsSkeleton />
      ) : (
        <>
          <div className="flex flex-col gap-4">
            <div className="flex gap-4">
              <SummaryPanel points={userPoints?.points} userRank={userRank} />
            </div>

            <Panel collapsibleOptions={{ collapsible: true }} className="bg-panel md:px-3">
              <Panel.Header>
                <Typography variant="p" className="pl-3 font-bold text-xl" gradient>
                  Running total
                </Typography>
              </Panel.Header>
              <Panel.Content>
                <WeeklyTable weeklyPoints={userPoints?.finishedWeeksPoints} />
              </Panel.Content>
            </Panel>
          </div>

          <LeaderboardContainer />
        </>
      )}
    </div>
  )
}
